<template>
  <div class="frame-wrapper paddy-field-add">
    <div class="sticky-message" v-if="initialized">
      ほ場を登録する場所をクリックしてマーカーをセットしてください。
    </div>
    <div class="centered-box-on-map register-paddyfields-buttons">
      <div class="centered-item">
        <div id="button-area">
          <span class="btn btn-submit" @click="onSubmitNewPaddyFields"
            >ほ場を登録</span
          >
          <span class="btn" @click="onCancelRegisterPaddyFields"
            >キャンセル</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GoogleMaps from "@/mixins/googlemaps.js";
import Loader from "@/mixins/loader";

export default {
  mixins: [GoogleMaps, Loader],

  data() {
    return {
      initialized: false,
      markers: [],
      newMarkers: [],
      clickMapListener: null,
    };
  },

  async mounted() {
    this.loading(async () => {
      // マーカー位置を決めやすいようcursorを変更する
      this.map.setOptions({ draggableCursor: "pointer" });

      this.$emit("showMap");
      this.clickMapListener = this.map.addListener("click", this.addMarker);
      try {
        await this.retrievePaddyFields();
        this.putMarkers();
        // 初期化終了フラグ
        this.initialized = true;
      } catch (error) {
        console.log(error);
        throw error;
      }
    });
  },

  destroyed() {
    this.map.setOptions({ draggableCursor: undefined });

    if (this.markers.length > 0) {
      // マーカーを削除
      this.markers.forEach((marker) => {
        marker.setMap(null);
      });
      this.markers = [];
    }
    if (this.newMarkers.length > 0) {
      // 追加マーカーを削除
      this.newMarkers.forEach((marker) => {
        marker.setMap(null);
      });
      this.newMarkers = [];
    }
    this.google.maps.event.removeListener(this.clickMapListener);
  },

  methods: {
    ...mapActions(["setMapMode", "insertPaddyFields", "retrievePaddyFields"]),
    ...mapGetters(["getPaddyFields"]),

    addMarker(e) {
      // マーカー追加
      const { Marker } = this.google.maps;
      const marker = new Marker({
        position: e.latLng,
        map: this.map,
        icon: {
          url: require("@/assets/pin/ricelog_pinicon_042.png"),
          scaledSize: new this.google.maps.Size(24, 42),
          anchor: { x: 12, y: 42 },
        },
      });
      this.newMarkers.push(marker);

      // このマーカーはクリックしたら削除
      marker.addListener("click", () => {
        marker.setMap(null);
        this.newMarkers = this.newMarkers.filter((e) => e !== marker);
      });
    },

    putMarkers() {
      const { Marker } = this.google.maps;
      let paddyFields = this.getPaddyFields();
      paddyFields.forEach((paddyField) => {
        const lat = parseFloat(paddyField.map_pos.split(",")[0]);
        const lng = parseFloat(paddyField.map_pos.split(",")[1]);

        const marker = new Marker({
          position: { lat: lat, lng: lng },
          map: this.map,
        });
        marker.setIcon(this.buildMarkerIconProps(paddyField.pin_type));
        marker.set("paddyField", paddyField);
        this.setInfoWindow(marker, paddyField);
        this.markers.push(marker);
      });
    },
    buildMarkerIconProps(iconName) {
      // アイコンファイル名の組み立て
      let iconProps = { url: this.buildMarkerIcon(iconName) };
      iconProps = Object.assign(iconProps, {
        scaledSize: { width: 24, height: 42 },
        anchor: { x: 12, y: 42 },
      });
      return iconProps;
    },

    buildMarkerIcon(iconName) {
      if (!iconName) {
        iconName = "ricelog_pinicon_040";
      }
      return require("@/assets/pin/" + iconName + ".png");
    },

    setInfoWindow(marker, paddyField) {
      var message = [];
      if (paddyField.name) {
        message.push(paddyField.name);
      }
      if (paddyField.area) {
        message.push(paddyField.area + "&nbsp(a)");
      }
      // 品種はマスタの値を表示
      if (paddyField.brand) {
        message.push(paddyField.brand);
      }
      // 耕作者
      if (paddyField.kousakusha) {
        message.push(paddyField.kousakusha);
      }
      var infowin = new this.google.maps.InfoWindow({
        content: message.join("<br>"),
      });

      // mouseoverイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseover", function () {
        infowin.open(marker.getMap(), marker);
      });

      // mouseoutイベントを取得するListenerを追加
      this.google.maps.event.addListener(marker, "mouseout", function () {
        infowin.close();
      });
    },

    async onSubmitNewPaddyFields() {
      if (this.newMarkers.length > 0) {
        this.loading(async () => {
          // 追加マーカーの緯度経度をカンマ区切りでjoin
          const latLongs = this.newMarkers.map((marker) => {
            return [
              marker.getPosition().lat(),
              marker.getPosition().lng(),
            ].join(",");
          });

          try {
            // 田圃登録
            // TODO エリアIDか何かが必要なはず
            await this.insertPaddyFields(latLongs);
            await this.retrievePaddyFields();
            this.$router.push({ name: "paddy-field-show" });
          } catch (error) {
            // TODO
            //NOP
          }
        });
      }
    },

    onCancelRegisterPaddyFields() {
      // TODO
      this.$router.push({ name: "paddy-field-show" });
    },
  },
};
</script>

<style lang="scss">
.paddy-field-add {
  &.frame-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .sticky-message {
    position: absolute;
    top: 0;
    width: 100%;
    background-color: var(--purple);
    color: white;
    text-align: center;
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    .btn {
      display: block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
      }
      &:nth-of-type(n + 2) {
        margin-left: 1rem;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
      }
    }
  }

  .centered-box-on-map {
    position: fixed;
    left: calc(50% + (250px / 2));
    z-index: 1;

    .centered-item {
      position: relative;
      left: -50%;
    }

    &.register-paddyfields-buttons {
      bottom: 0;
      margin-bottom: 1rem;
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
}
</style>
